import * as testimonieDiapoStyles from "../../styles/internal-page/testimonie-diapo.module.scss";

import React from "react";
import PolyLink from "../shared/PolyLink";
import IconContainer from "../shared/IconContainer";

const TestimonieContent = ({elem}) => {
	if (!elem) {
		return <></>
	}
	return (
		<>
			{(elem.quote || elem.content) && 
				<p className={testimonieDiapoStyles.citation}>
					<span
						className={testimonieDiapoStyles.caractere}
						dangerouslySetInnerHTML={{
							__html: "&laquo "
						}}
					/>
					<span
						className={testimonieDiapoStyles.detailText}
						dangerouslySetInnerHTML={{
							__html: elem.quote || elem.content.replace(/(<([^>]+)>)/ig, '')
						}}
					/>
					<span
						className={testimonieDiapoStyles.caractere}
						dangerouslySetInnerHTML={{
							__html: " &raquo"
						}}
					/>
				</p>
			}
			{elem.first_name && elem.last_name && 
				<p className={testimonieDiapoStyles.title}>
					{elem.first_name + " " + elem.last_name}
				</p>
			}
			{elem.name && 
				<p className={testimonieDiapoStyles.title}>
					{elem.name}
				</p>
			}
			<p className={testimonieDiapoStyles.job}>
				{[elem.job, elem.jobDescription].filter(e => e).join(', ')}
			</p>
			{elem.link && elem.link_label &&
				<PolyLink className={testimonieDiapoStyles.containerLink} url={elem.link} target={elem.link_new_window ? "_blank" : ""}>
					<p className={testimonieDiapoStyles.linkLabel}>
						{elem.link_label}
					</p>
					<IconContainer
						classname={testimonieDiapoStyles.more}
						icon="ARROW_RIGHT_NORMAL"
						color="RED"
						size={20}
						noHover
					/>
				</PolyLink>
			}
		</>
	);
};

export default TestimonieContent;
